import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Menu, Icon, Button, Dropdown, Popup, Message } from 'semantic-ui-react'

import AppConstants from '../../utils/AppConstants'
import ChangePasswordPopup from '../popups/users/ChangePasswordPopup'
import Grant from '../elements/Grant'

import LogoutAction from '../../actions/auth/LogoutAction'
import ChangePageAction from '../../actions/app/ChangePageAction'

import './MainHeader.css'

class MainHeader extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      isSettingsOpen: false,
      isChangingPassword: false,
      status: null,
      statusAppear: false,
      statusDisappear: false
    }

    // Bind events
    this.onClickChangePage = this.onClickChangePage.bind(this)
    this.onOpenSettings = this.onOpenSettings.bind(this)
    this.onCloseSettings = this.onCloseSettings.bind(this)
    this.onClickChangePassword = this.onClickChangePassword.bind(this)
    this.onCloseChangePassword = this.onCloseChangePassword.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.status !== this.props.status) {
      this.setState({
        status: this.props.status,
        statusAppear: true,
        statusDisappear: false
      })
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
      this.timeout = setTimeout(
        () => {
          this.setState({
            statusAppear: false
          })
          this.timeout = setTimeout(
            () => {
              this.setState({
                statusDisappear: true
              })
              this.timeout = setTimeout(
                () => {
                  this.setState({
                    status: null,
                    statusDisappear: false
                  })
                },
                1000
              )
            },
            4000
          )
        },
        500
      )
    }
  }

  onClickChangePage(page) {
    return () => {
      this.props.changePage(page)
    }
  }

  onOpenSettings() {
    this.setState({
      isSettingsOpen: true
    })
  }

  onCloseSettings() {
    this.setState({
      isSettingsOpen: false
    })
  }

  onClickChangePassword() {
    this.setState({
      isSettingsOpen: false,
      isChangingPassword: true
    })
  }

  onCloseChangePassword() {
    this.setState({
      isChangingPassword: false
    })
  }

  render() {
    const status = this.state.status
      ? <Menu.Item
          className={`status ${ this.state.statusAppear ? 'appear' : ''} ${ this.state.statusDisappear ? 'disappear' : ''}`}
          content={
            <Message
              content={
                <React.Fragment>
                  <Icon
                    name={AppConstants.STATUS.ICON[this.props.status.type]}
                  />
                  {this.props.status.message}
                </React.Fragment>
              }
              size='tiny'
              info={this.props.status.type === AppConstants.STATUS.TYPE.INFO}
              success={this.props.status.type === AppConstants.STATUS.TYPE.SUCCESS}
              warning={this.props.status.type === AppConstants.STATUS.TYPE.WARNING}
              error={this.props.status.type === AppConstants.STATUS.TYPE.FAILURE}
            />
          }
        />
      : null
    return (
      <React.Fragment>
        <Menu
          pointing={true}
          secondary={true}
        >
          <Menu.Header>
            GestMat
          </Menu.Header>
          <Dropdown
            item={true}
            text="Matériel"
          >
            <Dropdown.Menu>
              <Dropdown.Item
                text="Par Type"
                onClick={this.onClickChangePage(AppConstants.PAGE.PRODUCTS_VIEW)}
              />
              <Dropdown.Item
                text="Par Emplacement"
                onClick={this.onClickChangePage(AppConstants.PAGE.LOCATIONS_VIEW)}
              />
            </Dropdown.Menu>
          </Dropdown>
          <Dropdown
            item={true}
            text="Entretien"
          >
            <Dropdown.Menu>
              <Dropdown.Item
                text="Inventaire"
                onClick={this.onClickChangePage(AppConstants.PAGE.INVENTORY)}
              />
              <Dropdown.Item
                text="Contrôles"
                onClick={this.onClickChangePage(AppConstants.PAGE.CONTROL_LIST)}
              />
              <Dropdown.Item
                text="Maintenance"
                onClick={this.onClickChangePage(AppConstants.PAGE.MAINTENANCE_LIST)}
              />
            </Dropdown.Menu>
          </Dropdown>
          <Grant role={Grant.ROLE.MANAGE}>
            <Dropdown
              item={true}
              text="Gestion"
            >
              <Dropdown.Menu>
                <Grant role={Grant.ROLE.MANAGE}>
                  <Dropdown.Item
                    text="Types de matériel"
                    onClick={this.onClickChangePage(AppConstants.PAGE.PRODUCTS_MANAGE)}
                  />
                </Grant>
                <Grant role={Grant.ROLE.MANAGE}>
                  <Dropdown.Item
                    text="Emplacements"
                    onClick={this.onClickChangePage(AppConstants.PAGE.LOCATIONS_MANAGE)}
                  />
                </Grant>
                <Grant role={Grant.ROLE.MANAGE}>
                  <Dropdown.Item
                    text="Spécial"
                    onClick={this.onClickChangePage(AppConstants.PAGE.SPECIAL)}
                  />
                </Grant>
                <Grant role={Grant.ROLE.MANAGE}>
                  <Dropdown.Item
                    text="Paramètres"
                    onClick={this.onClickChangePage(AppConstants.PAGE.SETTINGS)}
                  />
                </Grant>
                <Grant role={Grant.ROLE.MANAGE}>
                  <Dropdown.Item
                    text={this.props.isAdmin ? "Utilisateurs" : "Personnel"}
                    onClick={this.onClickChangePage(AppConstants.PAGE.USERS)}
                  />
                </Grant>
              </Dropdown.Menu>
            </Dropdown>
          </Grant>
          {status}
          <Menu.Item
            position='right'
            fitted='vertically'
          >
            <Icon
              name='user'
              size='large'
            />
            {this.props.username}
            <Button.Group
              compact={true}
            >
              <Popup
                trigger={
                  <Button
                    icon='setting'
                  />
                }
                content={
                  <Button
                    compact={true}
                    content='Changer le mot de passe'
                    onClick={this.onClickChangePassword}
                  />
                }
                open={this.state.isSettingsOpen}
                onOpen={this.onOpenSettings}
                onClose={this.onCloseSettings}
                on='click'
              />
              <Button
                icon='window close'
                loading={this.props.isLogout}
                onClick={this.props.logout}
              />
            </Button.Group>
          </Menu.Item>
        </Menu>
        {
          this.state.isChangingPassword
            ? <ChangePasswordPopup
                onClose={this.onCloseChangePassword}
              />
            : null
        }
      </React.Fragment>
    )
  }
}

MainHeader.propTypes = {
  // Properties

  // Redux State
  username: PropTypes.string.isRequired,
  isLogout: PropTypes.bool.isRequired,
  currentPage: PropTypes.string.isRequired,
  status: PropTypes.object,
  isAdmin: PropTypes.bool.isRequired,

  // Redux Actions
  logout: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    username: state.app.identity.user.name,
    isLogout: state.app.identity.isFetching,
    currentPage: state.app.page,
    status: state.app.status,
    isAdmin: state.app.identity.user && state.app.identity.user.authorizations && state.app.identity.user.authorizations.admin
  }),
  (dispatch) => ({
    logout: () => (dispatch(LogoutAction({}))),
    changePage: (page) => (dispatch(ChangePageAction(page)))
  })
)(MainHeader)



// WEBPACK FOOTER //
// ./src/containers/headers/MainHeader.js